<template>
  <div>
    <ValidationObserver ref="observer" style="position: absolute;">
      <v-row no-gutters align="center">
        <v-col cols="12" md="6" class="pt-8">
          <modal-cadu :close="close" :width="800" v-model="show" @input="(value) => cancel()">
            <div slot="all" :class="$vuetify.breakpoint.xs ? 'pa-4 px-6 py-6' : 'pt-10 pb-4 px-10'">
              <div slot="header">
                <div class="font-primaria headline font-weight-bold pb-4" style="color: #00995d;">
                  ADICIONAR ANEXO
                </div>
              </div>
              <div slot="body">
                <v-row>
                  <v-col cols="12" md="8">
                    <validation-provider
                      name="tipoDocumento"
                      mode="eager"
                      rules="alpha_spaces|max:40|required"
                      v-slot="{ errors }"
                    >
                      <autocomplete-cadu
                        :items="listaTipoDocumento.map((el) => el.nome)"
                        :errorMessage="errors[0]"
                        onlyText
                        title="Tipo de documento"
                        v-model="tipoDocumento"
                      />
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="4">
                    <validation-provider
                      name="abaRelacionada"
                      mode="eager"
                      rules="alpha_spaces|max:40|required"
                      v-slot="{ errors }"
                    >
                      <autocomplete-cadu
                        :items="listaAbaRelacionada.map((el) => el.nome)"
                        :errorMessage="errors[0]"
                        onlyText
                        title="Aba Relacionada"
                        v-model="abaRelacionada"
                        :disabled="hasAba"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="3">
                    <validation-provider
                      name="anoDocumento"
                      mode="eager"
                      rules="yearValidatorForPast|required"
                      v-slot="{ errors }"
                    >
                      <input-cadu
                        :errorMessage="errors[0]"
                        title="Ano do documento"
                        v-model="anoDocumento"
                        :colorText="$vuetify.theme.themes.light.fontColor1"
                        :disabled="false"
                        onlyNumber
                        :max="'4'"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <div class="drag-doc-area">
                      <input
                        type="file"
                        @input="filesChange($event)"
                        accept=".jpg, .jpeg, .png, .pdf"
                        class="input-file"
                        :value="fileInput"
                      />
                      <v-row no-gutters align="center" justify="center" style="height: 100%;">
                        <v-col cols="12" md="6" class="drag-text-icon">
                          <v-row no-gutters justify="center" align="center" style="height: 100%;">
                            <v-col cols="5" md="3" class="icon">
                              <icon
                                name="paperclip"
                                :size="40"
                                style="cursor: pointer;"
                                class="mx-6 mt-5 mb-3"
                                tooltip="Anexar Documento"
                              />
                            </v-col>
                            <v-col cols="12" md="9" class="px-4 fontColor--text subtitle-2" v-if="file == ''">
                              Arraste e solte seu arquivo aqui ou <span class="text">clique</span> para localizar
                            </v-col>
                            <v-col cols="12" md="9" class="px-4 drag-Text-File" v-else>
                              <div>Nome do arquivo: {{ dadosArquivo.nome }}</div>
                              <div>Tamanho do arquivo: {{ dadosArquivo.tamanho }} KB</div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
                <p class="mx-4 my-2 fontColor--text subtitle-2">
                  O arquivo deve ter no máximo 15 MB e estar nos formatos PDF, JPG, JPEG ou PNG.
                </p>
              </div>
              <div slot="footer" class="pt-6">
                <div v-if="!$vuetify.breakpoint.xs">
                  <v-row align="start" justify="start">
                    <v-col cols="auto">
                      <button-cadu v-if="canEdit" outline @click="cancel()">
                        VOLTAR
                      </button-cadu>
                      <button-cadu v-else outline @click="cancel()">
                        CANCELAR
                      </button-cadu>
                    </v-col>
                    <v-row align="end" justify="end" class="mr-2">
                      <v-col cols="5">
                        <button-cadu
                          :backColor="$vuetify.theme.themes.light.primary2"
                          class="px-4"
                          block
                          @click="saveAnexo(true)"
                        >
                          SALVAR E ADICIONAR OUTRO
                        </button-cadu>
                      </v-col>
                      <v-col @click="saveAnexo()" cols="auto">
                        <button-cadu>
                          SALVAR
                        </button-cadu>
                      </v-col>
                    </v-row>
                  </v-row>
                </div>
                <div v-else>
                  <v-row>
                    <v-col @click="saveAnexo()" cols="12">
                      <button-cadu block>
                        SALVAR
                      </button-cadu>
                    </v-col>
                    <v-col cols="12">
                      <button-cadu
                        :backColor="$vuetify.theme.themes.light.primary2"
                        block
                        large
                        @click="saveAnexo(true)"
                      >
                        SALVAR E ADICIONAR OUTRO
                      </button-cadu>
                    </v-col>
                    <v-col cols="12">
                      <button-cadu block v-if="canEdit" outline @click="cancel()">
                        VOLTAR
                      </button-cadu>
                      <button-cadu v-else block outline @click="cancel()">
                        CANCELAR
                      </button-cadu>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </div>
          </modal-cadu>
        </v-col>
      </v-row>
    </ValidationObserver>
    <overlay-loading v-model="loadingImage" />
    <ErrorModal v-model="error" :errObj="errObj" />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import jwtDecode from 'jwt-decode'

import TipoDocumento from '@/services/Dominios/TipoDocumento'
import AbaRelacionada from '@/services/Dominios/AbaRelacionada'
import Anexo from '@/services/Anexos/Anexo'
import ErrorModal from '@/components/Shared/ErrorModal/ErrorModal'
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    ErrorModal
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    aba: {
      type: String,
      required: false
    }
  },
  data() {
    return {
      close: true,
      show: this.value,
      tipoDocumento: '',
      listaTipoDocumento: [],
      abaRelacionada: '',
      listaAbaRelacionada: [],
      anoDocumento: null,

      fileInput: '',
      inputFile: undefined,
      formData: new FormData(),
      file: '',
      dadosArquivo: {
        nome: '',
        tipo: '',
        tamanho: ''
      },
      validateSizeFile: false,
      validateTypeSize: false,
      role: '',

      error: false,
      errObj: {},
      loadingImage: false
    }
  },
  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    let decoded = jwtDecode(this.tokenBearer)
    this.role = decoded.role
    this.getDominios()
  },
  methods: {
    clearFile() {
      this.fileInput = ''
      this.inputFile = undefined
      this.formData = new FormData()
      this.file = ''
      this.dadosArquivo = {
        nome: '',
        tipo: '',
        tamanho: ''
      }
    },
    getDominios() {
      this.getTipoDocumento()
      this.getAbaRelacionada()
    },
    async getTipoDocumento() {
      let tipoDocumento = new TipoDocumento(this.tokenBearer, this.$appConfig.config.API)

      try {
        let responseTipoDocumento = await tipoDocumento.getTipoDocumento()
        this.listaTipoDocumento = responseTipoDocumento.data
      } catch (err) {
        this.listaTipoDocumento = []
      }
    },
    getAbaRelacionada() {
      let abaRelacionada = new AbaRelacionada()
      this.listaAbaRelacionada = abaRelacionada.getAbaRelacionada()
    },
    async filesChange(e) {
      this.fileInput = ''
      this.inputFile = undefined
      this.formData = new FormData()

      this.image = ''
      let files = e.target.files || e.dataTransfer.files
      this.inputFile = files[0]
      let file = files[0]

      this.validateTypeSize = false
      this.validateSizeFile = false

      this.dadosArquivo.nome = file.name
      this.dadosArquivo.tamanho = (file.size / 1024).toFixed(2)
      this.dadosArquivo.tipo = file.type
      this.createFile(files[0])
    },
    createFile(file) {
      var reader = new FileReader()
      var vm = this

      reader.onloadend = (e) => {
        vm.file = e.target.result
      }

      reader.readAsDataURL(file)
    },
    async putFile(createAnother) {
      this.loadingImage = true

      const anexo = new Anexo(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      const abaRelacionada = this.listaAbaRelacionada.find((item) => item.nome === this.abaRelacionada)
      const tipoDocumento = this.listaTipoDocumento.find((item) => item.nome === this.tipoDocumento)

      this.formData = new FormData()
      this.formData.append('arquivo', this.inputFile)
      this.formData.append('abaRelacionada', abaRelacionada.codigo)
      this.formData.append('tipoDocumentoId', tipoDocumento.id)
      this.formData.append('tipoDocumentoNome', tipoDocumento.nome)
      this.formData.append('anoDocumento', this.anoDocumento)

      await anexo
        .putAnexo(this.formData)
        .then(() => {
          if (createAnother) this.$emit('create-another')
          else this.$emit('reload-grid')
        })
        .catch((err) => {
          this.error = true
          if (err.response) {
            this.errObj.status = err.response.status
            this.errObj.error = err.response.data.message
          } else {
            this.errObj.status = 0
            this.errObj.error = 'O arquivo foi bloqueado por conter conteúdo não permitido. Tente com outro arquivo ou entre em contato com o suporte.'
          }
        })
        .finally(() => (this.loadingImage = false))
    },
    async cancel() {
      this.limparCampos()
      this.show = false
      this.$emit('cancel')
    },
    limparCampos() {
      this.tipoDocumento = ''
      this.abaRelacionada = ''
      this.anoDocumento = ''
      this.file = ''
    },
    async saveAnexo(createAnother = false) {
      if (await this.$refs.observer.validate()) await this.putFile(createAnother)
    }
  },
  computed: {
    canEdit() {
      return (
        this.role === 'admin_brasil' ||
        this.role === 'colaborador_brasil' ||
        this.role === 'colaborador_dirigente' ||
        this.role === 'admin' ||
        this.role === 'dirigente'
      )
    },
    hasAba() {
      if (this.aba) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    value() {
      this.show = this.value
      this.limparCampos()
      this.abaRelacionada = this.aba ? this.aba.toUpperCase() : null
      this.clearFile()
    }
  }
}
</script>

<style scoped>
.drag-doc-area {
  position: relative;
  border-radius: 22px;
  background-color: #dee2e6;
  width: 100%;
  height: 180px;
}

.drag-text-icon {
  width: 100%;
}

.icon {
  width: 100%;
  border-radius: 22px;
  background-color: #fff;
  color: #00995d;
}

.text {
  cursor: pointer;
  color: #00995d;
}

.input-file {
  opacity: 0;
  position: absolute;
  top: 0;
  height: 180px;
  width: 100%;
}

.drag-Text-File {
  font-family: 'Trebuchet MS' !important;
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.54);
}

.input-file :hover {
  cursor: pointer;
}
</style>
